var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    id: "svg150",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs154"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 8.361458,1.6747574 3.427461,3.8918594 c 0.119559,0.1374167 0.184568,0.3074411 0.184568,0.4825933 0,0.1751429 -0.06501,0.3451673 -0.184568,0.482584 L 8.361458,10.423691 C 8.214103,10.565479 8.0135168,10.651879 7.7993868,10.665796 7.5852663,10.67962 7.3731912,10.620028 7.2051471,10.498695 7.0370937,10.377363 6.9253071,10.203163 6.8918961,10.010468 6.8584854,9.8178776 6.9058883,9.6208689 7.0247269,9.4584756 L 9.3382645,6.8275782 H 0.89301676 c -0.22726254,0 -0.44521178,-0.08201 -0.60590775,-0.2279818 C 0.12641303,6.4536239 0.03613472,6.2556435 0.03613472,6.0492101 c 0,-0.2064428 0.09027829,-0.4044231 0.25097429,-0.5503957 C 0.44780498,5.3528417 0.66575422,5.2708327 0.89301676,5.2708327 H 9.3382645 L 7.0247269,2.6399439 C 6.943278,2.5615589 6.880641,2.4686681 6.8407759,2.3671466 6.8009108,2.2656347 6.7846958,2.1576963 6.7931489,2.0501877 c 0.00845,-0.1075083 0.041397,-0.2122526 0.096739,-0.3076 0.055342,-0.095339 0.1318872,-0.1791965 0.2247687,-0.2462666 0.092891,-0.067069 0.2001006,-0.1158804 0.3148387,-0.1433462 0.1147379,-0.027467 0.2345014,-0.032987 0.3517148,-0.016212 0.1172037,0.016774 0.2292988,0.055478 0.3291857,0.113661 0.099877,0.058185 0.1853706,0.1345716 0.2510622,0.2243335 z",
    fill: "#283856",
    id: "path148",
    style: {
      strokeWidth: 0.934045
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/Right.a70324c3233a4b7aaa76695d8660d5bd.svg";
export { ForwardRef as ReactComponent };